import { FC, Fragment, InputHTMLAttributes } from "react";

export type InputCardprops = InputHTMLAttributes<HTMLInputElement>;

export const InputCardPrincipal: FC<InputCardprops> = ({ ...props }) => {
  return (
    <Fragment>
      <input
        {...props}
        type="text"
        className="px-2 relative block w-full rounded-none rounded-t-md border-0 bg-transparent py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
      />
    </Fragment>
  );
};
